import { BaseAPIModel } from '@weezevent/weezjs-core';

/**
 * RedditionTaxModel.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class RedditionTaxCategoryModel extends BaseAPIModel {
    fields() {
        return {
            pk: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId }) {
        return `/ticket/organizations/${organizationId}/accountancy/reddition/${eventId}/tax-category`;
    }
}
